<template>
    <section class="how-it-works">
        <!-- /content-6-section -->
        <div class="content-12 text-left py-5">
            <div class="container pt-lg-3">
                <div class="section-desc">
                    ¿Te apasiona el deporte y te encanta predecir los
                    resultados? Con más de 16 años de experiencia, LePegue es la
                    plataforma multi-campeonato definitiva para vivir la emoción
                    del fútbol, fútbol americano, tenis y más.
                    <br /><br />
                    Participa en quinielas de grandes marcas para ganar premios
                    increíbles o crea tus propios torneos privados para competir
                    con amigos y familiares. Todo en un entorno seguro que
                    respeta tu privacidad.<br />
                    <br />
                    <h2 class="section-title">Por qué elegir LePegue</h2>
                    <ul>
                        <li>
                            Juega y gana con tus marcas favoritas: Ingresa los
                            códigos que recibes al hacer tus compras, desbloquea
                            partidos, registra tus predicciones y gana premios
                            espectaculares.
                        </li>
                        <li>
                            Quinielas privadas ilimitadas: Crea todas las
                            quinielas que quieras. Invita a tus amigos,
                            compañeros de oficina o familia para demostrar quién
                            es el verdadero experto.
                        </li>
                        <li>
                            Tu marca, tus reglas: ¿Tienes un negocio?
                            Personaliza tus quinielas configurando tu propio
                            logotipo para darle mayor presencia y alcance a tu
                            marca.
                        </li>
                        <li>
                            Notificaciones en tiempo real: No te pierdas ni un
                            solo detalle. Recibe alertas instantáneas con goles,
                            anotaciones y los acontecimientos más importantes de
                            cada partido.
                        </li>
                        <li>
                            Chat interactivo: Comparte con tus amigos un chat
                            privado donde todos los participantes pueden
                            participar
                        </li>
                        <li>
                            Privacidad 100% garantizada: Tu confianza es lo
                            primero. No compartimos tus datos con terceros ni
                            los usamos con fines económicos.
                        </li>
                    </ul>
                    <br />
                    <h2 class="section-title">Como empezar a jugar</h2>
                </div>
                <div class="content-info-tabs mt-4">
                    <div class="tab-main mx-auto text-md-center">
                        <input id="tab1" type="radio" name="tabs" checked />
                        <label for="tab1"
                            ><span
                                class="fas fa-download text-primary"
                                aria-hidden="true"
                            ></span>
                            Descarga la app</label
                        >
                        <input id="tab2" type="radio" name="tabs" />
                        <label for="tab2"
                            ><span
                                class="fas fa-user text-primary"
                                aria-hidden="true"
                            ></span>
                            Crea tu usuario</label
                        >

                        <input id="tab3" type="radio" name="tabs" />
                        <label for="tab3"
                            ><span
                                class="fas fa-qrcode text-primary"
                                aria-hidden="true"
                            ></span>
                            Ingresa el código</label
                        >
                        <input id="tab4" type="radio" name="tabs" />
                        <label for="tab4"
                            ><span
                                class="fa fa-trophy text-primary"
                                aria-hidden="true"
                            ></span>
                            Compite</label
                        >
                        <section id="content1" data-aos="zoom-in">
                            <img
                                src="/images/screen-1.png"
                                class="img-fluid"
                                alt="mobile-image"
                            />
                        </section>

                        <section id="content2" data-aos="zoom-in">
                            <img
                                src="/images/screen-2.png"
                                class="img-fluid"
                                alt="mobile-image"
                            />
                        </section>

                        <section id="content3" data-aos="zoom-in">
                            <img
                                src="/images/screen-3.png"
                                class="img-fluid"
                                alt="mobile-image"
                            />
                        </section>
                        <section id="content4" data-aos="zoom-in">
                            <img
                                src="/images/screen-4.png"
                                class="img-fluid"
                                alt="mobile-image"
                            />
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped>
.section-title {
    font-size: 28px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 10px;
}

.section-desc {
    font-size: 14px;
    color: #6c757d;
    line-height: 1.6;
    margin-bottom: 1.5rem;
}

.how-it-works .tab-main {
    padding: 0px 0;
    border: none;
    background: transparent;
    box-shadow: none;
}

.how-it-works .tab-main section {
    display: none;
    padding: 2em 0 0em 0;
    border-top: 1px solid transparent;
}

.how-it-works .tab-main section img {
    max-height: 500px;
    width: auto;
    display: block;
    margin: 0 auto;
}

.how-it-works .tab-main input {
    display: none;
}

.how-it-works .tab-main label {
    display: inline-block;
    margin: 0 20px;
    padding: 8px 15px;
    font-weight: 600;
    text-align: center;
    border: none;
    border-bottom: 2px solid transparent;
}

.how-it-works .tab-main span {
    display: block;
    margin-bottom: 10px;
    font-size: 22px;
}

.how-it-works .tab-main label:hover {
    /* color: #3dc7be; */
    cursor: pointer;
}

.how-it-works .tab-main input:checked + label {
    color: #334252;
    border: none;
    border-bottom: 2px solid #f75940;
}

.how-it-works .tab-main #tab1:checked ~ #content1,
.how-it-works .tab-main #tab2:checked ~ #content2,
.how-it-works .tab-main #tab3:checked ~ #content3,
.how-it-works .tab-main #tab4:checked ~ #content4 {
    display: block;
}

@media screen and (max-width: 992px) {
    .how-it-works .tab-main label {
        display: inline-block;
        margin: 0 10px;
        font-size: 18px;
    }
}

@media screen and (max-width: 767px) {
    .how-it-works .tab-main {
        text-align: center;
    }

    .how-it-works .tab-main label {
        padding: 12px 0px;
        margin: 0 10px;
        font-size: 14px;
        margin-bottom: 10px;
        text-align: center;
    }

    .how-it-works .tab-main span {
        display: inline-block;
        margin-bottom: 0px;
        font-size: 18px;
        vertical-align: middle;
        margin-right: 6px;
    }
}

@media screen and (max-width: 640px) {
    .how-it-works .tab-main label {
        font-size: 15px;
        width: 45%;
    }
}

@media screen and (max-width: 640px) {
    .how-it-works .tab-main label {
        font-size: 15px;
        width: 41%;
    }
}
</style>
